module.exports = __webpack_public_path__ + "img/iot-01.560a6c81.png";